export const slidesData = [
  {
    id: "001",
    img: "https://cdn.shopify.com/s/files/1/0130/5041/3114/files/home1_01_9e9ee306-65ab-4e2e-9a19-c54fa8039f8a_x1024.png",
    title: "Finde Premium Products",
    cta: "SHOP NOW",
  },
  {
    id: "002",
    img: "https://cdn.shopify.com/s/files/1/0130/5041/3114/files/home1_02_4c388999-0b9a-4a73-9fe7-1ca465ec8140_x1024.png",
    title: "Get all the Accessories you need",
    cta: "SHOP NOW",
  },
  {
    id: "003",
    img: "https://hongo.b-cdn.net/wp-content/uploads/2019/11/home-page-fashion-slider-01.jpg",
    title: "Wide  range of colors",
    cta: "SHOP NOW",
  },
];

export const FooterCardData = [
  {
    title: "Free Delivery",
    desc: "Phasellus blandit massa enim elit of passage varius nunc.",
    image: "/Images/footertruck.png",
  },
  {
    title: "30 Day Returns Guarantee",
    desc: "Phasellus blandit massa enim elit of passage varius nunc.",
    image: "/Images/footertruck.png",
  },
  {
    title: "27/4 Online Support",
    desc: "Phasellus blandit massa enim elit of passage varius nunc.",
    image: "/Images/footertruck.png",
  },
];
export const linksDataNavbar = [
  {
    name: "Home",
    link: "",
  },
  {
    name: "Shop",
    link: "category",
  },
  {
    name: "Blog",
    link: "blog",
  },

  {
    name: "Contact Us",
    link: "contact",
  },
];
